const checkTerms = document.querySelector("#terms");
const btnSubmit = document.querySelector(".btn-submit");

const toastSuccess = document.querySelector('.toast-success');
const toastError = document.querySelector('.toast-error');

checkTerms.addEventListener('change', enableButtonSubmit);


function enableButtonSubmit() {
    checkTerms.checked ? btnSubmit.disabled=false: btnSubmit.disabled = true;
}

document.addEventListener('DOMContentLoaded', () => {
    enableButtonSubmit();
});

if(toastSuccess || toastError){
    setTimeout(function() {
        $(".toasts-container").empty();
    }, 7000);
}

